import 'angular';
import './recent_views.html';
import '../controllers/RecentViewsComponentController';

export interface IRecentViewedService {
    getRecentViewedFilesActivity : () => ng.IPromise<any>
}

angular.module('GorillaBoy.Dboard')
.factory('RecentViewedService', [
    '$log',
    '$q',
    'AnalyticsService',
    function($log, $q, AnalyticsService) {
    var RecentViewedService:any = {};
    RecentViewedService.getRecentViewedFilesActivity = function(userId) {
        var params = {
            queryCategory: 'USER_ACTIVITIES',
            query: {
                "ActivityTypes":["DOCUMENT_VERSION_VIEWED"],
                "SearchActorId":userId,
                "ActivityScope":"DIRECT"},
            limit: 100
        };

        return AnalyticsService.getAnalytics(params).then(function(result) {
            return result.data.Items;
        }, function(err) {
            return $q.reject(err);
        });
    }

    return RecentViewedService;
 }])
.directive('recentViews', [
    () => {
    return {
        scope: true,
        controller: 'RecentViewsComponentController',
        templateUrl: './dboard/components/recent_views.html'
    };
}]);
